var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 138,
    viewBox: "0 0 209 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.164 87.4647C156.212 87.4668 155.284 87.7624 154.508 88.3107C153.732 88.859 153.146 89.633 152.831 90.5261H129.082L118.262 101.317H53.4574C53.6682 102.411 53.8907 103.423 54.0898 104.355H119.539L130.359 93.5758H152.831C153.114 94.3653 153.61 95.0623 154.265 95.5907C154.92 96.119 155.708 96.4585 156.543 96.5718C157.379 96.6852 158.23 96.5683 159.003 96.2337C159.776 95.8991 160.442 95.3598 160.928 94.6746C161.413 93.9894 161.7 93.1848 161.757 92.3484C161.814 91.5121 161.639 90.6763 161.251 89.9323C160.862 89.1883 160.276 88.5646 159.555 88.1295C158.834 87.6943 158.007 87.4643 157.164 87.4647ZM203.712 70.1208C202.759 70.1195 201.83 70.4137 201.053 70.9625C200.276 71.5113 199.691 72.2872 199.379 73.1822H141.718L129.75 61.251H90.0989L84.3843 66.9431H49.9092C49.9092 67.9674 49.9092 68.9917 49.9092 70.0044H85.6139L91.3285 64.3007H128.497L140.465 76.2319H199.403C199.686 77.0215 200.182 77.7185 200.837 78.2468C201.491 78.7752 202.279 79.1146 203.115 79.228C203.951 79.3414 204.801 79.2244 205.575 78.8898C206.348 78.5552 207.014 78.0159 207.499 77.3307C207.985 76.6455 208.272 75.8409 208.329 75.0046C208.386 74.1682 208.211 73.3325 207.823 72.5884C207.434 71.8444 206.847 71.2208 206.127 70.7856C205.406 70.3504 204.579 70.1205 203.736 70.1208H203.712ZM103.777 53.0912H168.745C169.107 54.1119 169.821 54.9724 170.759 55.5206C171.698 56.0689 172.802 56.2694 173.875 56.0869C174.948 55.9044 175.922 55.3505 176.623 54.5232C177.325 53.696 177.71 52.6486 177.71 51.5664C177.71 50.4842 177.325 49.4368 176.623 48.6095C175.922 47.7822 174.948 47.2284 173.875 47.0458C172.802 46.8633 171.698 47.0639 170.759 47.6121C169.821 48.1603 169.107 49.0209 168.745 50.0415H105.076L94.6659 39.6585H53.2583C52.9773 40.6712 52.7197 41.6955 52.4737 42.7198H93.3661L103.777 53.0912ZM117.478 36.3759H132.9C133.262 37.3966 133.975 38.2571 134.914 38.8053C135.853 39.3536 136.956 39.5541 138.03 39.3716C139.103 39.1891 140.076 38.6352 140.778 37.8079C141.48 36.9807 141.865 35.9333 141.865 34.8511C141.865 33.7689 141.48 32.7215 140.778 31.8942C140.076 31.0669 139.103 30.5131 138.03 30.3305C136.956 30.148 135.853 30.3486 134.914 30.8968C133.975 31.445 133.262 32.3056 132.9 33.3262H118.754L109.327 23.9442H60.144C60.0035 24.177 59.8395 24.3982 59.699 24.6193C59.2306 25.3992 58.7739 26.1908 58.3406 26.9474H108.098L117.478 36.3759ZM95.228 77.687H119.749C120.112 78.7271 120.834 79.6058 121.786 80.1672C122.739 80.7286 123.861 80.9363 124.953 80.7535C126.045 80.5707 127.037 80.0092 127.752 79.1687C128.467 78.3281 128.859 77.2629 128.859 76.1621C128.859 75.0613 128.467 73.996 127.752 73.1555C127.037 72.315 126.045 71.7535 124.953 71.5707C123.861 71.3879 122.739 71.5956 121.786 72.157C120.834 72.7184 120.112 73.5971 119.749 74.6372H93.9867L84.396 84.1938H50.8577C50.9631 85.2298 51.0802 86.2541 51.1973 87.2435H85.649L95.2397 77.687",
    fill: "url(#paint0_linear_167_687)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_167_687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 23,
    width: 160,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.165 87.4647C156.213 87.4668 155.285 87.7624 154.509 88.3107C153.733 88.859 153.147 89.633 152.832 90.5261H129.084L118.264 101.317H53.4589C53.6696 102.411 53.8922 103.423 54.0912 104.355H119.54L130.36 93.5758H152.832C153.116 94.3653 153.612 95.0623 154.266 95.5907C154.921 96.119 155.709 96.4585 156.545 96.5719C157.38 96.6852 158.231 96.5683 159.004 96.2337C159.777 95.8991 160.443 95.3597 160.929 94.6746C161.415 93.9894 161.702 93.1848 161.759 92.3484C161.816 91.5121 161.641 90.6763 161.252 89.9323C160.864 89.1883 160.277 88.5646 159.556 88.1295C158.836 87.6943 158.009 87.4643 157.165 87.4647ZM203.714 70.1208C202.761 70.1195 201.831 70.4137 201.055 70.9625C200.278 71.5113 199.693 72.2872 199.381 73.1822H141.719L129.751 61.251H90.1004L84.3857 66.9431H49.9106C49.9106 67.9674 49.9106 68.9917 49.9106 70.0044H85.6153L91.3299 64.3007H128.498L140.466 76.2319H199.404C199.687 77.0215 200.184 77.7185 200.838 78.2468C201.493 78.7752 202.281 79.1146 203.116 79.228C203.952 79.3414 204.803 79.2244 205.576 78.8898C206.349 78.5552 207.015 78.0159 207.501 77.3307C207.987 76.6455 208.274 75.8409 208.331 75.0046C208.388 74.1683 208.212 73.3325 207.824 72.5884C207.436 71.8444 206.849 71.2208 206.128 70.7856C205.407 70.3504 204.58 70.1205 203.737 70.1208H203.714ZM103.778 53.0912H168.747C169.109 54.1119 169.822 54.9724 170.761 55.5206C171.7 56.0689 172.803 56.2694 173.876 56.0869C174.949 55.9044 175.923 55.3505 176.625 54.5232C177.327 53.696 177.712 52.6486 177.712 51.5664C177.712 50.4842 177.327 49.4368 176.625 48.6095C175.923 47.7822 174.949 47.2284 173.876 47.0458C172.803 46.8633 171.7 47.0639 170.761 47.6121C169.822 48.1603 169.109 49.0209 168.747 50.0415H105.078L94.6674 39.6585H53.2598C52.9787 40.6712 52.7211 41.6955 52.4752 42.7198H93.3675L103.778 53.0912ZM117.479 36.3759H132.902C133.263 37.3966 133.977 38.2571 134.916 38.8053C135.854 39.3536 136.958 39.5541 138.031 39.3716C139.104 39.1891 140.078 38.6352 140.78 37.8079C141.482 36.9807 141.867 35.9333 141.867 34.8511C141.867 33.7689 141.482 32.7215 140.78 31.8942C140.078 31.0669 139.104 30.5131 138.031 30.3305C136.958 30.148 135.854 30.3486 134.916 30.8968C133.977 31.445 133.263 32.3056 132.902 33.3262H118.755L109.329 23.9442H60.1454C60.0049 24.177 59.841 24.3982 59.7005 24.6193C59.232 25.3992 58.7753 26.1908 58.3421 26.9474H108.099L117.479 36.3759ZM95.2295 77.687H119.751C120.114 78.7271 120.835 79.6058 121.788 80.1672C122.74 80.7286 123.862 80.9363 124.954 80.7535C126.047 80.5707 127.038 80.0092 127.753 79.1687C128.468 78.3281 128.861 77.2629 128.861 76.1621C128.861 75.0613 128.468 73.996 127.753 73.1555C127.038 72.315 126.047 71.7535 124.954 71.5707C123.862 71.3879 122.74 71.5956 121.788 72.157C120.835 72.7184 120.114 73.5971 119.751 74.6372H93.9882L84.3975 84.1938H50.8592C50.9646 85.2298 51.0817 86.2541 51.1988 87.2435H85.6505L95.2412 77.687",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_167_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.316 104.331V23.921H49.9106V104.331H208.316Z",
    fill: "url(#paint1_linear_167_687)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1629 0.0695398C89.1629 0.0695398 22.1215 -4.09764 14.8611 54.6038C14.1819 59.9816 14.3576 71.0863 12.402 76.1614C10.4463 81.2365 -1.32251 88.3021 0.164698 93.3656C1.08981 96.5434 12.8118 97.3233 12.8118 97.3233C12.8118 97.3233 8.54926 103.807 9.54464 105.867C10.1536 107.113 14.463 106.158 14.8611 107.485C15.3061 109.022 10.704 110.791 10.7742 112.374C10.8796 114.702 14.8611 116.448 17.3086 119.288C19.756 122.129 16.1375 131.441 18.4796 134.351C24.8149 141.975 35.9748 135.398 51.5495 112.374C51.5963 112.374 23.433 13.0949 89.1629 0.0695398Z",
    fill: "url(#paint2_linear_167_687)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1629 0.0695398C89.1629 0.0695398 22.1215 -4.09764 14.8611 54.6038C14.1819 59.9816 14.3576 71.0863 12.402 76.1614C10.4463 81.2365 -1.32251 88.3021 0.164698 93.3656C1.08981 96.5434 12.8118 97.3233 12.8118 97.3233C12.8118 97.3233 8.54926 103.807 9.54464 105.867C10.1536 107.113 14.463 106.158 14.8611 107.485C15.3061 109.022 10.704 110.791 10.7742 112.374C10.8796 114.702 14.8611 116.448 17.3086 119.288C19.756 122.129 16.1375 131.441 18.4796 134.351C24.8149 141.975 35.9748 135.398 51.5495 112.374C51.5495 112.374 23.3862 13.0949 89.1161 0.0695398",
    fill: "url(#paint3_linear_167_687)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_167_687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 138
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.162 0.0695399C89.162 0.0695399 22.1205 -4.09764 14.8601 54.6038C14.1809 59.9816 14.3566 71.0863 12.401 76.1614C10.4454 81.2365 -1.32349 88.3021 0.163721 93.3656C1.08883 96.5434 12.8108 97.3233 12.8108 97.3233C12.8108 97.3233 8.54829 103.807 9.54366 105.867C10.1526 107.113 14.462 106.158 14.8601 107.485C15.3051 109.022 10.703 110.791 10.7732 112.374C10.8786 114.702 14.8601 116.448 17.3076 119.288C19.755 122.129 16.1366 131.441 18.4786 134.351C24.8139 141.975 35.9738 135.398 51.5485 112.374C51.5485 112.374 23.3852 13.0949 89.1151 0.0695399",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_167_687)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.877 38.715L25.2017 -45.1409L-68.0474 99.1625L62.6395 183.03L155.877 38.715Z",
    fill: "url(#paint4_linear_167_687)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_167_687",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -69,
    y: -46,
    width: 225,
    height: 230
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.879 38.7151L25.2041 -45.1407L-68.0332 99.1626L62.642 183.019L155.879 38.7151Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_167_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.921 40.2516L26.1404 -40.4498L-62.729 97.0906L63.0279 177.792L151.921 40.2516Z",
    fill: "url(#paint5_linear_167_687)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_687",
    x1: 129.116,
    y1: 104.355,
    x2: 129.116,
    y2: 23.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_167_687",
    x1: 129.105,
    y1: 104.331,
    x2: 129.105,
    y2: 23.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_167_687",
    x1: 44.5942,
    y1: 137.379,
    x2: 44.5942,
    y2: 0.00512695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_167_687",
    x1: 44.5942,
    y1: 137.379,
    x2: 44.5942,
    y2: 0.00512695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_167_687",
    x1: 43.9026,
    y1: 183.03,
    x2: 43.9026,
    y2: -45.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_167_687",
    x1: 44.5842,
    y1: 177.792,
    x2: 44.5842,
    y2: -40.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEAC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBLogo);
export default __webpack_public_path__ + "static/media/BLogo.44626e7a913717711d5c4773973d9368.svg";
export { ForwardRef as ReactComponent };